class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');

    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      /*
        IMPORTANT:
        We removed this.open() from here.
        This stops the cart drawer from automatically opening after Add to Cart.
        Cart drawer will open only when the customer clicks the cart icon.
      */
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* Add to Cart tick mark - safe version */
(function () {
  let lastAddToCartButton = null;
  let fallbackTimer = null;

  function injectAddedStyle() {
    if (document.getElementById('hs-added-to-cart-style')) return;

    const style = document.createElement('style');
    style.id = 'hs-added-to-cart-style';
    style.textContent = `
      button[name="add"].hs-added-to-cart,
      .product-form__submit.hs-added-to-cart {
        background: linear-gradient(135deg, #d95f2f 0%, #e3783c 100%) !important;
        background-color: #df6b32 !important;
        color: #ffffff !important;
        border-color: transparent !important;
      }

      button[name="add"].hs-added-to-cart *,
      .product-form__submit.hs-added-to-cart * {
        color: #ffffff !important;
      }

      .hs-atc-check {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        font-weight: 900;
        animation: hsAtcCheckPop 0.25s ease;
      }

      @keyframes hsAtcCheckPop {
        0% {
          transform: scale(0.4);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getButtonLabel(button) {
    if (!button) return null;

    const directSpans = Array.from(button.children).filter((child) => {
      return (
        child.tagName === 'SPAN' &&
        !child.classList.contains('svg-wrapper') &&
        !child.classList.contains('visually-hidden') &&
        !child.classList.contains('loading__spinner')
      );
    });

    return directSpans[0] || null;
  }

  function showAddedTick(button) {
    if (!button || button.classList.contains('hs-added-to-cart')) return;

    injectAddedStyle();

    const label = getButtonLabel(button);
    const target = label || button;

    const oldHTML = target.innerHTML;

    button.classList.add('hs-added-to-cart');
    target.innerHTML = '<span class="hs-atc-check">✓</span>Added';

    setTimeout(() => {
      button.classList.remove('hs-added-to-cart');
      target.innerHTML = oldHTML;
    }, 2000);
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('form[action*="/cart/add"] button[name="add"]');

      if (!button) return;

      lastAddToCartButton = button;

      clearTimeout(fallbackTimer);

      fallbackTimer = setTimeout(() => {
        if (lastAddToCartButton) {
          showAddedTick(lastAddToCartButton);
          lastAddToCartButton = null;
        }
      }, 1200);
    },
    true
  );

  function connectCartUpdateEvent() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (!lastAddToCartButton) return;

        clearTimeout(fallbackTimer);

        setTimeout(() => {
          showAddedTick(lastAddToCartButton);
          lastAddToCartButton = null;
        }, 150);
      });

      return;
    }

    setTimeout(connectCartUpdateEvent, 200);
  }

  connectCartUpdateEvent();
})();